import classes from "../Kiosk_viennaPlzen_redesign.module.css";
import back from "../../../../store/Vienna_new/65506-200.png";
import room
    from "../../../../store/Vienna_new/Vienna House Easy by Wyndham Pilsen - Restaurant - 1550227.jpg";
import {React, useEffect, useState} from "react";
import axios from "axios";
import { path, assetsBaseUrl } from "../../../../routes";
import UndoIcon from '@mui/icons-material/Undo';

const Eat = (props) => {

    const [currentIndexA, setCurrentIndexA] = useState(0);
    const [cards, setCards] = useState([])
    const [qr, setQR] = useState("")
    const [group, setGroup] = useState(18)

    // Bottom image(s) under EAT: configurable via Kiosk slideshow group "eat-bottom"
    const EAT_BOTTOM_GROUP_NAME = 'eat-bottom';
    const ORG_ID_VIENNA_PLZEN = '62BDEE7F-9CE9-41BE-A80C-EF69F045D56C';
    const [eatBottomGroupId, setEatBottomGroupId] = useState(null);
    const [eatBottomCards, setEatBottomCards] = useState([]);
    const [eatBottomIndex, setEatBottomIndex] = useState(0);

    const setObje = (x) => {
        let fld = []
        for (let i = 0; i < x.length; i++) {
            const id = x[i].id
            try {
                let temp = {
                    id: id,
                    Header: x[i].description,
                    CreatedBy: x[i].username,
                    Body: {
                        file: x[i].path,
                        //imgURL: `https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png`,//fileContent,
                        imgURL: assetsBaseUrl + x[i].path
                    }
                }
                fld.push(temp)
            } catch (error) {
                console.error('Fetching elevators Error:', error.message);
            }
        }
        console.log(fld)
        setCards([...fld])
    }

    const fetchDataCards = async (gr) => {
        try {
            const response = await axios.get(`${path}/getCardsV3?orgID=62BDEE7F-9CE9-41BE-A80C-EF69F045D56C&group=${gr}&onlyVisible=1`);
            console.log(response.data);
            // Optionally, update your UI to reflect the deletion
            setObje(response.data)
        } catch (error) {
            console.error('Error deleting row:', error);
        }
    }

    const apiCandidates = (endpoint) => {
        const base = String(path || '').replace(/\/$/, '');
        const ep = String(endpoint || '').replace(/^\/+/, '');
        const c1 = `${base}/${ep}`;
        const c2 = base.endsWith('/api') ? base.replace(/\/api$/, '') + '/' + ep : `${base}/api/${ep}`;
        return Array.from(new Set([c1, c2]));
    };

    const getWithFallback = async (endpoint) => {
        let lastErr;
        for (const url of apiCandidates(endpoint)) {
            try {
                return await axios.get(url);
            } catch (e) {
                lastErr = e;
                if (e?.response?.status && e.response.status !== 404) throw e;
            }
        }
        throw lastErr;
    };

    const postWithFallback = async (endpoint, body) => {
        let lastErr;
        for (const url of apiCandidates(endpoint)) {
            try {
                return await axios.post(url, body);
            } catch (e) {
                lastErr = e;
                if (e?.response?.status && e.response.status !== 404) throw e;
            }
        }
        throw lastErr;
    };

    const ensureEatBottomGroup = async () => {
        try {
            const res = await getWithFallback(`getSlideGroup?orgID=${encodeURIComponent(ORG_ID_VIENNA_PLZEN)}`);
            const groups = Array.isArray(res.data) ? res.data : [];
            const found = groups.find(g => String(g.groupName || '').trim().toLowerCase() === EAT_BOTTOM_GROUP_NAME);
            if (found?.groupId != null) {
                setEatBottomGroupId(Number(found.groupId));
                return Number(found.groupId);
            }
            const created = await postWithFallback('createSlideGroup', {
                groupName: EAT_BOTTOM_GROUP_NAME,
                orgID: ORG_ID_VIENNA_PLZEN,
                deviceIds: [],
                showOnTotem: false
            });
            const newId = created?.data?.groupId != null ? Number(created.data.groupId) : null;
            if (newId != null && Number.isFinite(newId)) {
                setEatBottomGroupId(newId);
                return newId;
            }
        } catch (e) {
            console.warn('[Eat] Failed to ensure eat-bottom group:', e?.message);
        }
        setEatBottomGroupId(null);
        return null;
    };

    const setBottomCardsFromApi = (x) => {
        const raw = Array.isArray(x) ? x : [];
        const mapped = raw.map((it) => ({
            id: it.id,
            imgURL: assetsBaseUrl + String(it.path || '')
        })).filter(c => c.imgURL);
        setEatBottomCards(mapped);
    };

    const fetchEatBottomCards = async (gid) => {
        if (!gid) {
            setEatBottomCards([]);
            setEatBottomIndex(0);
            return;
        }
        try {
            const response = await axios.get(`${path}/getCardsV3?orgID=${encodeURIComponent(ORG_ID_VIENNA_PLZEN)}&group=${gid}&onlyVisible=1`);
            setBottomCardsFromApi(response.data);
        } catch (e) {
            setEatBottomCards([]);
            setEatBottomIndex(0);
        }
    };
    const fetchQRCards = async () => {
        try {
            const response = await axios.get(`${path}/getCardsV3?orgID=62BDEE7F-9CE9-41BE-A80C-EF69F045D56C&group=23&onlyVisible=1`);
            console.log(response.data);
            // Optionally, update your UI to reflect the deletion
            setQR(assetsBaseUrl + response.data[0].path)
        } catch (error) {
            console.error('Error deleting row:', error);
        }
    }
    useEffect(() => {
        const timer = setTimeout(() => {
            props.reset();
        }, 2* 60* 1000); // spustí se po 10 vteřinách

        return () => {
            clearTimeout(timer); // vyčisti timeout při unmountu
        };
    }, []);
    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentIndexA((prevIndex) => (prevIndex + 1) % cards.length);
        }, 15000);
        return () => {
            clearInterval(intervalId);
        };
    }, [cards]);

    useEffect(() => {
        if (eatBottomCards.length <= 1) return;
        const intervalId = setInterval(() => {
            setEatBottomIndex((prev) => (prev + 1) % eatBottomCards.length);
        }, 15000);
        return () => clearInterval(intervalId);
    }, [eatBottomCards.length]);

    useEffect(() => {
        if (eatBottomCards.length === 0) {
            setEatBottomIndex(0);
            return;
        }
        setEatBottomIndex((i) => (i >= eatBottomCards.length ? 0 : i));
    }, [eatBottomCards.length]);
    useEffect(() => {
        //console.warn("ajojda")
        fetchDataCards(18)
        fetchQRCards()
    }, [])

    // Load + refresh "eat-bottom" slideshow images (bottom area)
    useEffect(() => {
        let cancelled = false;
        let refreshId = null;
        let gidLocal = null;

        (async () => {
            gidLocal = await ensureEatBottomGroup();
            if (cancelled) return;
            await fetchEatBottomCards(gidLocal);
            if (cancelled) return;
            // keep it fresh so newly uploaded images show up quickly
            refreshId = setInterval(() => {
                if (!cancelled) fetchEatBottomCards(gidLocal);
            }, 3000);
        })();

        return () => {
            cancelled = true;
            if (refreshId) clearInterval(refreshId);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return<> <div className={classes.slideshowMenu}>
        <div className={classes.menuBackbt} onClick={()=>{props.setStep(0)}}>
            <img src={back}/>
        </div>
        <div className={classes.menuLine}>
            <div
                className={`${classes.buttonCirc} ${classes.sleepBTsubmenu} `} onClick={()=>{props.setStep(1)}}>Sleep
            </div>
            <div
                className={`${classes.buttonCirc} ${classes.eatBTsubmenu} ${classes.activebt}`}>Eat
            </div>
            <div
                className={`${classes.buttonCirc} ${classes.meetBTsubmenu}`} onClick={()=>{props.setStep(3)}}>Meet
            </div>
            <div
                className={`${classes.buttonCirc} ${classes.exploreBTsubmenu}`} onClick={()=>{props.setStep(4)}}>Explore
            </div>
        </div>
        {cards.length > 0 && <img src={cards[currentIndexA].Body.imgURL}/>}
        {cards.length == 0 && <img src={room}/>}

    </div>
        <div className={classes.sleepBody}>

            <div className={classes.eatTxt}>
                <div className={classes.row2}>
                    <label className={classes.headText}>Restaurant</label>
                    <label className={classes.headTextSedy}>Opening hours</label>
                    <label className={classes.headTextprosty}>Monday through Friday:</label>
                    <label className={classes.headTextprosty}> 6.30 a.m. - 10.30 a.m.</label>
                    <label className={classes.headTextprosty}> Saturday and Sunday:</label>
                    <label className={classes.headTextprosty}>6.30 a.m. - 11.00 a.m. </label>
                </div>
                <div className={classes.lineRest}></div>
                <div className={classes.row2}>
                    <label className={classes.headText}>Bar</label>
                    <label className={classes.headTextSedy}>Opening hours</label>
                    <label className={classes.headTextprosty}>Daily 7.00 a.m. - midnight</label>
                    <div className={classes.qr}><img src={qr}/></div>

                </div>
            </div>
            <div className={classes.sleepPic}>
                {eatBottomCards.length > 0 ? (
                    <img src={eatBottomCards[eatBottomIndex % eatBottomCards.length]?.imgURL} alt="eat bottom" />
                ) : (
                    // Fallback to bundled default image until admin uploads images to group "eat-bottom"
                    <img src={room} alt="eat bottom default" />
                )}
            </div>
        </div></>
}
export default Eat;